document.addEventListener("DOMContentLoaded", function () {
  const buttons = document.querySelectorAll(".toggle-btn");
  const slider = document.querySelector(".toggle-slider");
  const speciesSection = document.querySelector(".species-section");
  const speciesListContainer = document.createElement("div");
  speciesListContainer.classList.add("species-list");

  // Insert the species list container into the DOM (near the red arrow area)
  const toggleContainer = document.querySelector(".season-toggle");
  toggleContainer.insertAdjacentElement("afterend", speciesListContainer);

  // Function to sort entries alphabetically
  function sortEntriesAlphabetically(entries) {
    return entries.sort((a, b) => {
      const titleA = a.querySelector(".title").innerText.toLowerCase();
      const titleB = b.querySelector(".title").innerText.toLowerCase();
      return titleA.localeCompare(titleB);
    });
  }

  // Function to filter and display entries based on season
  function filterEntries(season) {
    // Filter entries by season and sort alphabetically
    const entries = [...speciesSection.querySelectorAll('.entry')];
    const filteredEntries = entries.filter(
      (entry) => entry.dataset.season === season
    );
    const sortedEntries = sortEntriesAlphabetically(filteredEntries);

    // Clear and update the species list
    updateSpeciesList(sortedEntries);

    // Hide all entries and only show those that match the filtered season
    entries.forEach((entry) => {
      const title = entry.querySelector('.title').textContent.trim();
      entry.style.display = filteredEntries.some(e => e === entry) ? 'block' : 'none';
    });
  }

  // Function to update the species list
  function updateSpeciesList(filteredEntries) {
    speciesListContainer.innerHTML = ""; // Clear existing list

    if (filteredEntries.length > 0) {
      filteredEntries.forEach((entry) => {
        const speciesName = entry.querySelector('.title').textContent.trim();

        const speciesLink = document.createElement("a");
        speciesLink.href = "#";
        speciesLink.textContent = speciesName;
        speciesLink.setAttribute("data-species", speciesName);

        speciesLink.addEventListener("click", (e) => {
          e.preventDefault();

          // Hide all entries, then show the selected species
          filteredEntries.forEach((entry) => {
            const title = entry.querySelector('.title').textContent.trim();
            entry.style.display = title === speciesName ? "block" : "none";
          });

          // Update active link
          document.querySelectorAll('.species-list a').forEach((link) => link.classList.remove('active'));
          speciesLink.classList.add('active');
        });

        speciesListContainer.appendChild(speciesLink);
      });
    } else {
      speciesListContainer.innerHTML = "<p>No species available for this season.</p>";
    }
  }

  // Initialize visibility on page load (filter for Spring season initially)
  filterEntries("Spring");

  // Event listener for toggle buttons
  buttons.forEach((button, index) => {
    button.addEventListener("click", function () {
      // Remove active class from all buttons
      buttons.forEach((btn) => btn.classList.remove("active"));
      // Add active class to clicked button
      button.classList.add("active");

      // Move the slider to the active button position
      slider.style.transform = `translateX(${index * 100}%)`;

      // Filter and display entries for the selected season
      const season = button.id.replace("-btn", ""); // Extract season from button ID
      filterEntries(season.charAt(0).toUpperCase() + season.slice(1)); // Capitalize season
    });
  });
});